import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["id", "value", "checked", "onChange"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "center-wrapper mobile-nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EasyDrop = _resolveComponent("EasyDrop")!

  return (_openBlock(), _createBlock(_component_EasyDrop, {
    customClasses: 'airports',
    isFullMobile: true,
    position: 'center',
    hasTopTip: true,
    customButtonClasses: 'easy-icon-plane main-drop search-btn',
    buttonId: 'searchAirportBtn',
    ref: "easyDrop"
  }, {
    buttonText: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.selectedAirport.name) + " (" + _toDisplayString(_ctx.selectedAirport.id) + ") ", 1)
    ]),
    contentHeader: _withCtx(() => [
      (_ctx.pageTexts['searchbarDepartureAirportInfoPopup'])
        ? (_openBlock(), _createBlock(_component_EasyDrop, {
            key: 0,
            dropdownType: 'tooltip',
            position: 'right'
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", {
                class: "rte",
                innerHTML: _ctx.pageTexts['searchbarDepartureAirportInfoPopup']
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.pageTexts['searchbarDepartureAirportHeadline']), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.pageTexts['searchbarDepartureAirportSubheadline']), 1)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("fieldset", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayAirports, (airport, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("input", {
              type: "radio",
              id: airport.id,
              value: airport.id,
              name: "Airports",
              checked: airport.isSelected,
              onChange: ($event: any) => (_ctx.setSelectedAirport(airport)),
              hidden: ""
            }, null, 40, _hoisted_2),
            _createElementVNode("label", {
              class: "easy-icon-plane",
              for: airport.id
            }, [
              _createElementVNode("span", null, [
                _createElementVNode("strong", null, _toDisplayString(airport.name), 1),
                _createTextVNode(_toDisplayString(airport.id), 1)
              ])
            ], 8, _hoisted_3)
          ], 64))
        }), 128))
      ])
    ]),
    contentFooter: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isHotelApp)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.nextDrop && _ctx.nextDrop(...args)))
            }, _toDisplayString(_ctx.pageTexts['hotelPageNavigationButtonNext']), 1))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)))
            }, _toDisplayString(_ctx.pageTexts['hotelPageGeneralNavigationButtonSave']), 1))
      ])
    ]),
    _: 1
  }, 512))
}